const escapeXml = (value) =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');

const escapeCsv = (value) => {
  const str = String(value ?? '');
  if (str === '') return '';
  // Force text so Excel keeps UI date format with / (not locale -)
  return `"=""${str.replace(/"/g, '""')}"""`;
};

const buildCsv = (headers, rows) => {
  const headerLine = headers.map((h) => escapeCsv(h)).join(',');
  const dataLines = rows.map((row) => row.map((cell) => escapeCsv(cell)).join(','));
  return [headerLine, ...dataLines].join('\r\n');
};

const buildSpreadsheetML = (headers, rows, sheetName = 'Sheet1') => {
  const headerRow = headers
    .map(
      (header) =>
        `<Cell ss:StyleID="sText"><Data ss:Type="String">${escapeXml(header)}</Data></Cell>`
    )
    .join('');
  const dataRows = rows
    .map(
      (row) =>
        `<Row>${row
          .map(
            (cell) =>
              `<Cell ss:StyleID="sText"><Data ss:Type="String">${escapeXml(cell)}</Data></Cell>`
          )
          .join('')}</Row>`
    )
    .join('');

  return `<?xml version="1.0"?>
<?mso-application progid="Excel.Sheet"?>
<Workbook xmlns="urn:schemas-microsoft-com:office:spreadsheet"
 xmlns:o="urn:schemas-microsoft-com:office:office"
 xmlns:x="urn:schemas-microsoft-com:office:excel"
 xmlns:ss="urn:schemas-microsoft-com:office:spreadsheet">
 <Styles>
  <Style ss:ID="sText">
   <NumberFormat ss:Format="@"/>
  </Style>
 </Styles>
 <Worksheet ss:Name="${escapeXml(sheetName)}">
  <Table>
   <Row>${headerRow}</Row>
   ${dataRows}
  </Table>
 </Worksheet>
</Workbook>`;
};

const downloadAsExcel = (headers, rows, fileName = 'export.xls', sheetName = 'Sheet1') => {
  const name = (fileName || 'export.xls').toLowerCase();
  const isCsv = name.endsWith('.csv');
  const hasKnownExt =
    isCsv || name.endsWith('.xls') || name.endsWith('.xlsx');

  const content = isCsv
    ? buildCsv(headers, rows)
    : buildSpreadsheetML(headers, rows, sheetName);

  const blob = new Blob(['\ufeff', content], {
    type: isCsv
      ? 'text/csv;charset=utf-8;'
      : 'application/vnd.ms-excel;charset=utf-8;',
  });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = hasKnownExt ? fileName : `${fileName}.xls`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

const onExport = async (action, value) => {
  let form = document.createElement('form');
  form.method = 'post';
  form.target = '_blank';
  form.action = action;
  form.innerHTML = `'<input type="text"  name="model"  value=${JSON.stringify(
    value
  )}>'`;
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

const getUpdatedFilter = (filterName, filterValue, arry, hasDate) => {
  let fil = [...arry.filters];
  const index = fil.findIndex(
    (item) => item.filterName === filterName && filterName != 'dateofservice'
  );

  let hasDateFilterType = '';
  if (hasDate === 'startDate') {
    hasDateFilterType = 7;
  }
  if (hasDate === 'endDate') {
    hasDateFilterType = 6;
  }
  if(filterName=="rxNumber")
  {
    hasDateFilterType=3;
  }

  if (index >= 0) {
    fil[index] = {
      filterName,
      filterValue,
      filterType: hasDateFilterType || 1,
    };
  } else {
    fil = [
      ...fil,
      ...[
        {
          filterName,
          filterValue,
          filterType: hasDateFilterType || 1,
        },
      ],
    ];
  }
  return fil;
};

const getUpdatedFilterLatest = (filterName, filterValue, arry, hasDate) => {
  let fil = [...arry];
  const index = fil.findIndex(
    (item) => item.filterName === filterName && filterName != 'dateofservice'
  );

  let hasDateFilterType = '';
  if (hasDate === 'startDate') {
    hasDateFilterType = 7;
  }
  if (hasDate === 'endDate') {
    hasDateFilterType = 6;
  }
  if(filterName=="rxNumber")
  {
    hasDateFilterType=3;
  }

  if (index >= 0 && !filterValue) {
    fil.splice(index, 1);
  } else if (index >= 0) {
    fil[index] = {
      filterName,
      filterValue,
      filterType: hasDateFilterType || 1,
    };
  } else {
    fil = [
      ...fil,
      ...[
        {
          filterName,
          filterValue,
          filterType: hasDateFilterType || 1,
        },
      ],
    ];
  }
  return fil;
};

export { onExport, downloadAsExcel, getUpdatedFilter, getUpdatedFilterLatest };
